import { isAbortError } from "@dpdgroupuk/fetch-client"; // eslint-disable-next-line import/first

import { set } from "lodash/object";
import { FAILED_TO_FETCH, FAILED_TO_FETCH_ERROR_MESSAGE_$, IS_NOT_ALLOWED, SOMETHING_WENT_WRONG } from "./constants";
export const formatMessage = (template, ...args) => template.replace(/{(\d)}/g, (s, num) => args[num]);
export const getErrorMessage = (e, failedToFetchEntityName) => {
  if (e.errors && e.errors[0] && e.errors[0].message) {
    return e.errors[0].message;
  }

  if (e.errors && e.errors.message) {
    return e.errors.message;
  }

  if (e.message) {
    if (e.message && e.message.includes(FAILED_TO_FETCH)) {
      return formatMessage(FAILED_TO_FETCH_ERROR_MESSAGE_$, failedToFetchEntityName);
    }

    return e.message;
  }

  return SOMETHING_WENT_WRONG;
};
export const isUnauthorizedUserError = err => err.statusCode === 401;
export const isIgnoredError = err => isAbortError(err) || isUnauthorizedUserError(err);
export const defaultErrorMapper = (errors = []) => {
  const mappedErrors = {};
  errors.forEach(({
    message,
    fieldName,
    fieldPath
  }) => {
    fieldName && message && set(mappedErrors, fieldPath, message);
  });
  return mappedErrors;
};
export const getValidFieldErrors = errors => errors.filter(({
  message
}) => !message.includes(IS_NOT_ALLOWED));